import { IconFolder } from '@tabler/icons';

// constant
const icons = {
    IconFolder
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const main = {
    id: 'main',
    type: 'group',
    children: [
        {
            id: 'documentale',
            title: 'Documentale',
            type: 'item',
            url: '/documentale',
            icon: icons.IconFolder,
            breadcrumbs: false
        }
    ]
};

export default main;
